module.exports = {
	"START": "Start",
	"SINGLE_TYPED": "Single-typed",
	"DOUBLE_TYPED": "Double-typed",
	"BASIC": "Basic",
	"SPEEDRUN": "Speedrun",
	"HOME": "home",
	"ATTACK": "Attack",
	"DEFEND": "Defend",
	"GOAL": "GOAL",
	"GOAL_BASIC": "answer in 60 sec",
	"GOAL_SPEEDRUN": "score 20",
	"TIMER": "timer",
	"SCORES": "scores",
	"YOUR_SCORES": "Your scores",
	"YOUR_TIME": "Your time",
	"RETRY": "Retry",
	"MENU": "Menu",
	"LANGUAGE": "Language",
	"NORMAL": "normal",
	"FIGHTING": "fighting",
	"FLYING": "flying",
	"POISON": "poison",
	"GROUND": "ground",
	"ROCK": "rock",
	"BUG": "bug",
	"GHOST": "ghost",
	"STEEL": "steel",
	"FIRE": "fire",
	"WATER": "water",
	"GRASS": "grass",
	"ELECTRIC": "electric",
	"PSYCHIC": "psychic",
	"ICE": "ice",
	"DRAGON": "dragon",
	"DARK": "dark",
	"FAIRY": "fairy",
	"EFFECTIVE_0": "not effective",
	"EFFECTIVE_1_2": "not very effective",
	"EFFECTIVE_1": "effective",
	"EFFECTIVE_2": "super effective",
	"ENEMY_ATTACK": "attack enemy",
	"ENEMY_DEFEND": "defend against enemy"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lang/strings.json
 ** module id = 320
 ** module chunks = 0
 **/